var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-muted m-0 pt-1 pl-3 text-left text-sm-right"},[_c('small',[_vm._v(" Made by tetric0 ")])])}]

export { render, staticRenderFns }